import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {getSystemMsg} from '../utils/api';
import { cartActions } from '../store/cart';
import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const Minor = (props) => {

    return (
			<div className={TestInfoClasses.testInfo}>
				<div className={TestInfoClasses.testInfoContent}>
					<div className={TestInfoClasses.buttonArea}>
			    		<span>&nbsp;</span>
			    		<span>I'm sorry, you must be at least 18 years of age to order lab tests.</span>
			    		<span>&nbsp;</span>
		    		</div>
		    	</div>
            </div>
        
    );
};
export const NoService = (props) => {
    return (
			<div className={TestInfoClasses.testInfo}>
				<div className={TestInfoClasses.testInfoContent}>
					<div className={TestInfoClasses.buttonArea}>
			    		<span>&nbsp;</span>
			    		<span>I'm sorry, the lab does not service your area.</span>
			    		<span>&nbsp;</span>
		    		</div>
		    	</div>
            </div>
        
    );
};
export const NoServiceSysMsg = (props) => {
	const dispatch = useDispatch();
	const [sysMsg,setSysMsg] = useState('');
	useEffect(() => {
	  const fetchSystemMsg = async () => {
		try {
		  const response = await getSystemMsg("Restricted States");
		  const resData = await response;
		  setSysMsg(resData);
		} catch (err) {
		  console.error("Error fetching system message:", err);
		}
	  };

	  fetchSystemMsg();
	}, []);
	dispatch(cartActions.emptyCart());
    return (
			<div className={TestInfoClasses.testInfo}>
				<div className={TestInfoClasses.testInfoContent}>
					<div className={TestInfoClasses.buttonArea}>
			    		<span>&nbsp;</span>
			    		<span>{sysMsg}</span>
			    		<span>&nbsp;</span>
		    		</div>
		    	</div>
            </div>
        
    );
};
export default Minor;